// components/UserProfileInputs/SignInput.tsx

import React from "react";
import styled from "styled-components";
import { P, match } from "ts-pattern";
import removeQueryParameters from "utils/removeQueryParameters";

interface SignInputProps {
  label: string;
  src?: string | null;
}

export const UserProfileSignInput: React.FC<SignInputProps> = ({
  label,
  src,
}) => {
  return (
    <SignInputLayout>
      <p>{label}</p>
      <SignContainer>
        {match(src)
          .with(P.string, (src) => {
            return <img src={removeQueryParameters(src)} alt="sign-image" />;
          })
          .with(P.nullish, () => {
            return <p>미등록</p>;
          })
          .exhaustive()}
      </SignContainer>
    </SignInputLayout>
  );
};

const SignInputLayout = styled.div`
  p {
    ${({ theme }) => theme.typography.body1.medium};
    margin-bottom: 1rem;
  }

  ${({ theme }) => theme.media.small} {
    display: flex;
    gap: 1rem;

    p {
      ${({ theme }) => theme.typography.body3.medium};
      min-width: 7rem;
    }
  }
`;

const SignContainer = styled.div`
  width: 13.8rem;
  height: 13.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 1px dashed ${({ theme }) => theme.color.stroke.dark};
  background-color: ${({ theme }) => theme.color.background.default};
  color: ${({ theme }) => theme.color.text.secondary};
  ${({ theme }) => theme.typography.body1.regular};

  > img {
    border-radius: 5px;
    object-fit: scale-down;
    width: 100%;
  }

  ${({ theme }) => theme.media.small} {
    width: 10rem;
    height: 10rem;
    flex-direction: column;

    > img {
      width: 10.7rem;
      height: 10.7rem;
    }
    > p {
      margin: auto;
      text-align: center;
    }
  }
`;

UserProfileSignInput.displayName = "UserProfileSignInput";
export default UserProfileSignInput;
